import { useMemo } from 'react';

import { isGoGameEnv } from 'App/constants';

import { useScreenState } from '@gogame/screens';

import { useChartState } from './useChartState';

export const useCanLoadAnnotations = () => {
  const chartState = useChartState();
  const screenState = useScreenState();

  return useMemo(() => {
    return (
      chartState.annotations.showAnnotations &&
      screenState.charts.length === 1 &&
      screenState.filtersCollection.length === 1 &&
      isGoGameEnv
    );
  }, [chartState, screenState, isGoGameEnv]);
};
